// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","form":"styles_form__XXK4y","submit":"styles_submit__GYE8+","innerForm":"styles_innerForm__-PynH","section":"styles_section__6xzw+"};